
import React, { useEffect, useState } from 'react';

import SellCarDataTable from '../../../components/admin/enquiries/SellCarDataTable';

const SellCarList: React.FC = () => {

    return (
        <div id="wrapper">

            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <div className="container-fluid">
                        <div>
                            <SellCarDataTable />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SellCarList;